import {FieldNames} from "../../models/clients-filedNames.enum"

export const activeClientsColumns = (t: any) => [
  {
    key: "resultName",
    name: t('clients.columns.name'),
    fieldName: FieldNames.NAME,
    minWidth: 300,
    maxWidth: 500,
    isResizable: true,
  },
  {
    key: "Street",
    name: t('clients.columns.address'),
    fieldName: FieldNames.ADDRESS,
    minWidth: 300,
    maxWidth: 500,
    isResizable: true,
  },
  {
    key: "receptionPlacesOrderTypes",
    name: t('clients.columns.orderTypes'),
    fieldName: FieldNames.ORDERTYPE,
    minWidth: 300,
    maxWidth: 500,
    isResizable: true,
  },
  {
    key: "importedFromCuo",
    name: t('clients.columns.source'),
    fieldName: "importedFromCuo",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
];